import React, {useEffect, useState} from 'react';
import QrReader from 'react-qr-reader';
import {connect} from 'react-redux';
import { toastr } from 'react-redux-toastr';
import { Button } from 'reactstrap';
import { withRouter } from '../../utils/withRouter';
import { mustBeArray } from '../../utils/lib';
import {updateTank, validateTank} from '../../actions/tankActions';
import querySearch from "stringquery";
import { push } from '../../utils/navigation';
import { BASE_URL, isNullEmptyOrWhitespace } from '../../constants';
import _ from 'lodash-es';

const QrAssetRolloutIndex = props => {
    const {run,runId, pickupDetails, updateTank , locationId, dispatch} = props;
    const [tanks, setTanks] = useState([]);
    const [activeTank, setActiveTank] = useState({});
    const [manualInputMode, setManualInputMode] = useState(false);
    const [canScan, setCanScan] = useState(false);
    const [saveLoading, setSaveLoading] = useState(false);
    useEffect(() => {
        setTanks(mustBeArray(pickupDetails.pickupTanks));
    }, [pickupDetails && pickupDetails.locationID]);

    const onScan = (data) => {
        if (data && canScan) {
            if (data.includes('?')) {
                let split = data.split('?');
                let query = querySearch(`?${split[1]}`);
                handleValidateTankId({tankId: query && query.tankId});
            } else {
                setCanScan(true);
            }
        }
      };
    
      const onError = data => {
          console.log(data);
      };
      const handleQrSelect = tank => {
          setActiveTank(tank);
          setManualInputMode(false);
          setCanScan(true);
      };
      const handleManualInputMode = tank => {
          setActiveTank(tank);
          setManualInputMode(true);
          setCanScan(false);
      };
      const handleManualInputModeCancel = () => {
        setActiveTank({});
        setManualInputMode(false);
      };
      const handleTankIdChange = value => {
          setActiveTank({...activeTank, updatedTankID: value});
      };
      const handleValidateTankId = ({tankId, manualMode=false}) => {
          const runId = pickupDetails && pickupDetails.runId;
          const latitude = pickupDetails && pickupDetails.locationLatitude;
          const longitude = pickupDetails && pickupDetails.locationLongitude;
          const pickupId = pickupDetails && pickupDetails.id;
          if(isNullEmptyOrWhitespace(tankId)){
              return toastr.error(`Tank ID is required`);
          }
          dispatch(validateTank({tankId, runId, pickupId, latitude, longitude, assetRollout:true})).then(x => {
            if(x.data && x.data.notAssetRollout){
                toastr.error(`Tank #${tankId} is NOT an asset rollout tank type`);
            }
            else if(x.data && x.data.notFound){
                toastr.error(`Tank #${tankId} information NOT found.`);
            }
            else {
                toastr.success(`Tank #${tankId} information found`);
                let updatedTank = tanks.map((tank) => {
                    if(tank.tankID === activeTank.tankID){
                        tank.updatedTankID = tankId;
                    }
                    return tank;
                });
                setActiveTank({});
                setTanks(updatedTank);
                setManualInputMode(false);
            }
          });
      };
    const handleSaveAndUpdate = () => {
        setSaveLoading(true);
        const pickupId = pickupDetails && pickupDetails.id;
        let tempTanks = _.filter(tanks, o => o.updatedTankID);
        let updatedTanks = tempTanks.reduce((a,b) => {
            return a.concat({oldTankId: b.tankID, newTankId: Number(b.updatedTankID), pickupTankId: b.id});
        },[]);
        // validating duplicates
        let newTanks = updatedTanks.reduce((a,b) => {
            return a.includes(b.newTankId) ? a : a.concat(b.newTankId);
        },[]);
        if((newTanks).length < updatedTanks.length){
            setSaveLoading(false);
            return toastr.error("Duplicate tank id assigned.");
        }
        let payLoad = {
            locationId,
            pickupId,
            tanks: updatedTanks
        };
        dispatch(updateTank({payLoad})).then(x => {
            if (!x || (!x.error && !( x.data && x.data.Message))) {
                toastr.success("Saved tanks.");
                dispatch(push(`${BASE_URL}/runs/driver/${runId}`));
              }
        });
    };
    return(
        <React.Fragment>
            <h4 className="text-danger" style={{marginBottom: "24px"}}>QR-Asset Rollout Tool</h4>
            {
                pickupDetails && 
                <React.Fragment>
                    <h6>{pickupDetails.clientCompanyName}</h6>
                    <a href={`http://maps.google.com/maps?&z=21&q=${pickupDetails.locationLatitude}+${pickupDetails.locationLongitude}`} 
                                    target={'_blank'}>{`${pickupDetails.locationLatitude}, ${pickupDetails.locationLongitude}`}</a>
                     <div style={{marginBottom: "24px"}}><i className="icon-location-pin" />&nbsp;{pickupDetails.locationFullAddress}</div>
                     {
                         tanks.map((tank,i) => {
                             return(
                                <div key={i} style={{marginBottom: "32px"}}>
                                    <div style={{maxWidth: "400px",  padding: "14px 24px", backgroundColor: "rgb(220 223 224)", marginBottom: "12px"}} className="text-primary">
                                        <b>Tank: #{tank.tankID} - {tank.tankCapacityLitres}L</b>
                                    </div>
                                    {
                                            manualInputMode && (activeTank.tankID === tank.tankID) ?
                                            <div style={{maxWidth: "400px"}}>
                                                <input placeholder="Enter tank Id" style={{width: "100%", padding: "12px"}} 
                                                            onChange={e => handleTankIdChange(e.currentTarget.value)}/>
                                                <div style={{display: "flex", justifyContent: "space-between", marginTop: "10px"}}>
                                                    <button className={'btn btn-success mr-1 hand'} onClick={() => handleValidateTankId({tankId: activeTank.updatedTankID, manualMode: true})}>
                                                        <i className={'fa fa-check fa-2x'}/>
                                                    </button>
                                                    <button className={'btn btn-danger hand'} onClick={handleManualInputModeCancel} >
                                                        <i className={'fa fa-times fa-2x'} />
                                                    </button> 
                                                </div>
                                            </div>
                                            :
                                            <div style={{maxWidth: "400px", alignItems: "stretch", display:"flex"}}>
                                                <div style={{flex: "1 1 90%", padding: "18px 18px", textAlign: "center", borderTopLeftRadius: "4px", borderBottomLeftRadius: "4px",
                                                                            backgroundColor: "rgb(116 139 150)", color: "#fff", fontWeight: "600", cursor: "pointer"}} 
                                                                            onClick={e => handleManualInputMode(tank)}>
                                                    {`${tank.updatedTankID ? `#${tank.updatedTankID}` : "Tap for manual input"}`}
                                                </div>
                                                <div style={{flex: "1 1 10%", borderTopRightRadius: "4px", borderBottomRightRadius: "4px", display:"flex", justifyContent:"center", 
                                                                            alignItems: "center", backgroundColor: "#c0d3e0b0"}} onClick={e => handleQrSelect(tank)}>
                                                    <i className="fa fa-qrcode" style={{fontSize: "24px", cursor: "pointer"}}/>
                                                </div>
                                            </div>
                                    }
                                    {
                                            canScan && (activeTank.tankID === tank.tankID) &&
                                            <QrReader
                                                delay={300}
                                                onError={onError}
                                                onScan={onScan}
                                                style={{width: '100%', maxWidth:"400px", marginTop: "12px"}}
                                            />
                                    }
                                </div>
                                    );
                                })
                     }
                     
                     <Button color="success"
                        onClick={e => handleSaveAndUpdate()}
                        style={{width: "100%", maxWidth: "400px", fontWeight: "600", padding: "14px 0", cursor: "pointer"}}
                        >
                            SAVE & UPDATE
                    </Button>
                </React.Fragment>
            }

        </React.Fragment>
    );
};

function mapStateToProps(state, ownProps){

    let runId = parseInt(ownProps.routeParams.id);
    let locationId = parseInt(ownProps.routeParams.locationId);
    let pickupDetails = {};
    let run = null;

    //look at state.driverRuns and state.searchRuns, attempt to get the run from there


    if(runId && state.driverRuns && state.driverRuns.items.length > 0){
        let filteredRun = state.driverRuns.items.find(x => x.id === runId);
        if(filteredRun){
            pickupDetails = _.find(filteredRun.pickups, o => o.locationID === locationId);
        }
    }
    if(state.run && state.run.id === runId){
        run = state.run;
    }
    if(!run){
        run = {};
    }

    return {
        run: run,
        runId: runId,
        account: state.account,
        locationId,
        driverRuns: {...state.driverRuns},
        pickupDetails
    };
}
  
  function mapDispatchToProps(dispatch) {
    return {
      dispatch,
      updateTank,
      validateTank
    };
  }
  
  export default withRouter(connect(mapStateToProps, mapDispatchToProps)(QrAssetRolloutIndex));